module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/logo_amex.2dc1fd72.svg";